import { getPermissions } from "../../api/permission";
import _ from "lodash";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import { i18n } from "../../language";
import { setPersistenceData } from "../../utils/persistenceStorage";
import { getPermissionsFormLocalStorage } from "../../utils/chat";

const permission = {
    namespaced: true,
    state: {
        permissions: getPermissionsFormLocalStorage(),
    },
    getters: {
        groupedPermissions(state) {
            return _.sortBy(state.permissions || [], (q) => {
                try {
                    return PERMISSION_TYPES[q.name][i18n.locale].entity.toUpperCase();
                } catch (e) {
                    return q.entity.toUpperCase();
                }
            }).reduce((acc, permission) => {
                acc[permission.entity] = acc[permission.entity] || [];
                acc[permission.entity].push(permission);
                return acc;
            }, {});
        },
    },
    mutations: {
        SET_PERMISSIONS: (state, payload) => {
            state.permissions = payload;
            setPersistenceData("permissions", JSON.stringify(payload), true);
        },
    },
    actions: {
        async getPermissions({ commit }) {
            const { data } = await getPermissions();
            commit("SET_PERMISSIONS", data);
        },
    },
};

export default permission;
